<template>
  <div class="body-container-activity border-container">
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Widget, FirebaseApp } from "@/components/services/participant-service";
import localStorageService from "@/services/localStorage";
export default {
  name: "activity-dashboard",
  data() {
    return {
      firebase: null,
      widget: new Widget()
    };
  },
  computed: {
    ...mapGetters(["participant"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  created() {
    this.registerDevice().then(res => {
      if (res) {
        this.permitNotifications();
      }
    });
  },
  methods: {
    registerDevice() {
      return new Promise((resolve, reject) => {
        this.$api
          .getFirebaseApp(this.participant.pid, {
            studyId: this.participant.studyId
          })
          .then(response => {
            const data = response.body;
            if (Object.keys(data).includes("appId") && Object.keys(data).includes("webConfig")) {
              this.firebase = new FirebaseApp(JSON.parse(data.webConfig), JSON.parse(data.appId).appId);
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    permitNotifications() {
      const isAllowNotification = localStorageService.getItem("pweb-allow-notification");
      this.firebase
        .getToken()
        .then(() => {
          if (isAllowNotification == "false" || !isAllowNotification) {
            const message = this.widget.translate("push_enable_text", "Please allow app to receive notifications.");
            this.$toastr.success(message);
            localStorageService.setItem("pweb-allow-notification", true);
          }
        })
        .catch(() => {
          if (isAllowNotification == "false" || !isAllowNotification) {
            const message = this.widget.translate("push_enable_text", "Please allow app to receive notifications.");
            this.$toastr.success(message);
            localStorageService.setItem("pweb-allow-notification", true);
          }
        });
    }
  }
};
</script>

<style>
.activity-progress-row {
  padding: 13px 0 10px 0;
}

.calender-icon {
  margin-top: -5px;
}
.progress {
  border: solid 1px var(--primary);
  background-color: #f3f3f3;
  height: 12px;
  margin-top: 5px;
  border-radius: 10px;
}
.progress-bar {
  background-color: var(--primary);
}
.calender-icon .vdp-datepicker__calendar .cell {
  height: 42px !important;
  line-height: 42px !important;
  font-weight: bold;
  border-radius: 50%;
}

.calender-icon .vdp-datepicker__calendar .cell.selected {
  line-height: 40px !important;
  border-radius: 50%;
}

.vdp-datepicker__calendar .cell.day-header {
  font-size: 75%;
  white-space: nowrap;
  cursor: inherit;
}

.calender-icon .calendar_btn .vdp-datepicker__calendar {
  right: -39px;
  top: 38px;
  padding: 0 11rem;
  width: 725px;
  height: auto;
}
</style>
